import React from 'react';
import styles from './index.module.scss';

export type ImagePropsType = { src: string; alt?: string };

type AllImagePropsType = ImagePropsType & {
	className?: string;
	onImgLoad?: () => void;
};

export function Image({
	src,
	alt = 'campaign image',
	className,
	onImgLoad = () => {},
}: AllImagePropsType) {
	return (
		<img
			className={`${styles.image} ${className}`}
			src={src}
			alt={alt}
			onLoad={({ currentTarget }) => {
				currentTarget.style.display = 'block';
				onImgLoad();
			}}
			onError={() => {
				onImgLoad();
			}}
		/>
	);
}
